angular
  .module('countriesApp')
  .service('ConsultantModel', [
    'ConsultantMinimalModel',
    function (ConsultantMinimal) {
      return class ConsultantModel extends ConsultantMinimal {
        constructor(data) {
          super(data);

          this.last_name = data.last_name;
          this.first_name = data.first_name;
        }
      };
    }
  ]);
